<template>
    <div>
        <StudiewijzerIcon v-if="losseModules" 
            class="w-5"
            classIcon="text-indigo w-4 h-4"
            :faIcon="['far', 'check-circle']"
            tooltipText="losse modules die kunnen leiden tot een <b>deelcertificaat</b>"
            :megamenu="megamenu"
        />
       <StudiewijzerIcon v-if="beroepsCertificaat" 
            class="w-5"
            classIcon="text-teal w-4 h-4"
            faIcon="tasks"
            tooltipText="opleiding die kan leiden tot een <b>certificaat</b>"
            :megamenu="megamenu"
        />
        <StudiewijzerIcon v-if="diplomeerbaar" 
            class="w-5"
            classIcon="text-diploma w-4 h-4"
            faIcon="graduation-cap"
            tooltipText="opleiding die kan leiden tot een <b>diploma</b>"
            :megamenu="megamenu"
        />
    </div>
</template>

<script setup>
    const props = defineProps({
        studiewijzer: {
            type: Array,
            default: [],
        },
        megamenu: {
            type: Boolean,
            default: false,
        }
    })

    const losseModules = computed(() => props.studiewijzer.includes('Losse modules'));
    const beroepsCertificaat = computed(() => props.studiewijzer.includes('Beroepscertificaat'));
    const diplomeerbaar = computed(() => props.studiewijzer.includes('Diplomeerbaar'));

</script>
